import React, { useState, useEffect } from "react";
import { Button, Popover } from "@mui/material";
import { useSelector } from "react-redux";
import CoreFilterButtonIcon from "../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";
import { useTranslation } from "react-i18next";
import { ROLE } from "../../../utils/constants/profiles";

const GestisciStudioFilter = ({
  rolesData,
  filter,
  setFilter,
  studios,
  setDebouncedInputStudioValue,
}) => {
  const { t } = useTranslation();
  const role = useSelector((state) => state.app.role);
  const [anchorEl, setAnchorEl] = useState(null);
  const [studio, setStudio] = useState();
  const [formData, setFormData] = useState({
    identityRoleId: "",
    studioId: "",
  });

  const optionRoles = rolesData?.map((role) => {
    return { label: role.name, value: role.id };
  });

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFilter = () => {
    setFilter(formData);
    //handleClosePopover();
  };

  const handleReset = () => {
    setFormData({
      identityRoleId: "",
      studioId: "",
    });
    setFilter({
      identityRoleId: "",
      studioId: "",
    });
    setStudio();
  };

  useEffect(() => {
    if (studio?.id)
      setFormData({
        ...formData,
        studioId: studio?.id,
      });
    else
      setFormData({
        ...formData,
        studioId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            marginTop: "5px",
            overflow: "visible",
          },
        }}
      >
        <div className="w-[32rem] p-4">
          <form>
            <div className="flex flex-col ">
              <h3 className="mb-2">{`${t("FilterByOperatorsType")}`}</h3>
              <CoreSelectObjArr
                name="identityRoleId"
                label={`${t("OperatorType")}`}
                value={formData.identityRoleId}
                items={optionRoles}
                onChange={handleInputChange}
              />
            </div>

            {role === ROLE.ADMIN && (
              <div className="flex flex-col ">
                <h3 className="mb-2 ">{`${t("FilterByStudios")}`}</h3>
                <StudioFilter
                  selectedUser={studio}
                  setSelectedUser={setStudio}
                  usersList={studios?.Data?.items}
                  setDebouncedInputUserValue={setDebouncedInputStudioValue}
                />
              </div>
            )}
            <div className="flex space-x-4  justify-center">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
              {/*               <Button
                className="text-white w-full"
                style={{ backgroundColor: `${colorPrimary}` }}
                onClick={handleFilter}
                sx={{ marginTop: "16px" }}
              >
                {t("Apply")}
              </Button> */}
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default GestisciStudioFilter;
